import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import config from '../config';

/**
 * Custom hook to fetch active customers from Stripe
 * @returns {Object} Object containing customers data, loading state, and error state
 */
export const useActiveCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  useEffect(() => {
    const fetchCustomers = async () => {
      if (!isAuthenticated) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);

        // Get access token
        const token = await getAccessTokenSilently();
        
        // Fetch customers from API
        const response = await fetch(`${config.API_URL}/api/active-customers`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || 'Failed to fetch customers');
        }

        const data = await response.json();
        console.log('Fetched customers:', data.customers);
        setCustomers(data.customers || []);
      } catch (err) {
        console.error('Error fetching customers:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCustomers();
  }, [getAccessTokenSilently, isAuthenticated]);

  return { customers, isLoading, error };
};
